var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-referral-info-list-status",class:{
        _accented: _vm.code === 'invested',
    }},[_c('div',{staticClass:"page-cabinet-referral-info-list-status__text",domProps:{"textContent":_vm._s(_vm.statusText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }